import React from 'react'
import './Spinner.css'
import MySpinner from 'react-bootstrap/Spinner'
export default function Spinner(props) {
  return (
    <>
      <MySpinner className='spinner' animation='border' role='status' aria-hidden='true' {...props}>
        <span className='sr-only '>Loading...</span>
      </MySpinner>
    </>
  )
}

export const SmallSpinner = () => (
  <>
    <MySpinner animation='border' role='status' as='span' aria-hidden='true' size='sm'>
      <span className='sr-only '>Loading...</span>
    </MySpinner>
  </>
)
